module.exports = __webpack_public_path__ + "img/wd-bg3-8b56e1.png";